import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import style from './TemperatureChart.module.scss';

export default function TemperatureChart(props) {
  const { dataTemperatureChart, isExport } = props;
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(dataTemperatureChart);
    }
  }, [dataTemperatureChart]);

  const updateDataset = (listOne) => {
    chartInstance.data.datasets = installDataset(listOne);
    chartInstance.update();
  };

  const installDataset = (listOne) => {
    let newList = [
      {
        type: 'line',
        unit: 'W/m2',
        label: 'Solar Irradiance',
        data: listOne.data,
        parsing: {
          yAxisKey: 'irra',
          xAxisKey: 'ts',
        },
        backgroundColor: '#ff3c2e',
        borderColor: '#ff3c2e',
        borderWidth: 2,
        yAxisID: 'y1',
      },
      {
        type: 'line',
        unit: '°C',
        label: 'Temperature',
        data: listOne.data,
        parsing: {
          yAxisKey: 'temp',
          xAxisKey: 'ts',
        },
        borderColor: '#038cfc',
        borderWidth: 2,
        backgroundColor: '#038cfc',
        // fill: true,
      },
    ];
    return newList;
  };

  const data = {
    datasets: [
      {
        type: 'line',
        unit: 'W/m2',
        label: 'Solar Irradiance',
        data: dataTemperatureChart.data,
        parsing: {
          yAxisKey: 'irra',
          xAxisKey: 'ts',
        },
        backgroundColor: '#ff3c2e',
        borderColor: '#ff3c2e',
        borderWidth: 2,
        yAxisID: 'y1',
      },
      {
        type: 'line',
        unit: '°C',
        label: 'Temperature',
        data: dataTemperatureChart.data,
        parsing: {
          yAxisKey: 'temp',
          xAxisKey: 'ts',
        },
        borderColor: '#038cfc',
        borderWidth: 2,
        backgroundColor: '#038cfc',
        // fill: true,
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      elements: {
        point: {
          radius: 0,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      maintainAspectRatio: false,
      plugins: {
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        legend: {
          display: true,
          labels: {
            // This more specific font property overrides the global property
            font: {
              size: isExport ? 8 : 14,
            },
            color: '#000',
          },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
          ticks: {
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
        },
        y: {
          title: {
            display: false,
            text: 'Temperature',
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
          ticks: {
            callback: function (value, index, values) {
              return `${value.toLocaleString()} °C`;
            },
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
        },
        y1: {
          type: 'linear',
          display: true,
          position: 'right',
          title: {
            display: false,
            text: 'Solar Irradiance W/m2',
            // color: '#fcc603',
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
              lineHeight: 1.2,
            },
            color: '#000',
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} W/m2`;
            },
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          },
          min: 0,
        },
      },
    },
  };

  return (
    <div className={style.chart}>
      <canvas ref={chartRef} />
    </div>
  );
}
TemperatureChart.propTypes = {
  isExport: PropTypes.bool,
  dataTemperatureChart: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        power: PropTypes.number,
        irra: PropTypes.number,
        temp: PropTypes.number,
      })
    ),
    value: PropTypes.string.isRequired,
  }).isRequired,
};
